import BugReportIcon from '@mui/icons-material/BugReport';
import { Button, DialogActions, DialogContent, Divider, Stack, Typography } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import { Trans } from 'react-i18next';

interface LinterErrorsDialogProps {
  ignoreAction?: 'run' | 'deploy';
  onClose: () => void;
  onIgnoreAndDeploy?: () => void;
}

const LinterErrorsDialog = ({ ignoreAction = 'deploy', onClose, onIgnoreAndDeploy }: LinterErrorsDialogProps) => {
  const handleBack = () => {
    onClose();
  };

  const handleIgnoreAndDeploy = () => {
    onIgnoreAndDeploy?.();
  };

  return (
    <>
      <DialogTitle variant="dialogTitle" align="center">
        <Trans i18nKey="linterErrorsDialog.title">Your Program has linter errors</Trans>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ px: 4, py: 5 }}>
        <Stack direction="row" spacing={2} alignItems="flex-start">
          <BugReportIcon sx={{ mt: 0.25, color: 'text.primary' }} aria-hidden />
          <Typography variant="body1">
            {ignoreAction === 'run' ? (
              <Trans i18nKey="linterErrorsDialog.message.run">
                If you run with linter errors, your program may not work correctly. We recommend fixing all errors.
              </Trans>
            ) : (
              <Trans i18nKey="linterErrorsDialog.message">
                If you deploy with linter errors, your program may not work correctly. We recommend fixing all errors.
              </Trans>
            )}
          </Typography>
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ justifyContent: 'space-between', px: 3, py: 1.5 }}>
        <Button variant="text" onClick={handleBack}>
          <Trans i18nKey="linterErrorsDialog.button.back">Back</Trans>
        </Button>
        <Button variant="text" autoFocus onClick={handleIgnoreAndDeploy}>
          {ignoreAction === 'run' ? (
            <Trans i18nKey="linterErrorsDialog.button.ignoreAndRun">Ignore &amp; Run</Trans>
          ) : (
            <Trans i18nKey="linterErrorsDialog.button.ignoreAndDeploy">Ignore &amp; Deploy</Trans>
          )}
        </Button>
      </DialogActions>
    </>
  );
};

export default LinterErrorsDialog;
